import CustomDownloadChartButton from '@/components/Chart/ExportButton/CustomDownloadChartButton';
import ExportChartButton from '@/components/Chart/ExportButton/ExportChartButton';
import type { ChartType } from '@/components/Chart/types/highcharts';
import { CsvWidgetExportButton } from '@/components/CsvTableWidget/CsvWidgetExport/CsvWidgetExportButton';
import ExportWidgetButton from '@/pages/Markets/MarketsComponents/components/ExportWidgetButton';
import type { BaseTabType } from '@/types/markets';

const TabExportButton = ({ tab }: { tab: BaseTabType }) => {
  if (tab.type === 'graph') {
    return tab.metadata?.graphType === 'custom' ? (
      <CustomDownloadChartButton
        metadata={tab.metadata}
        tabName={tab.name}
      />
    ) : (
      <ExportChartButton
        graphType={tab.metadata?.graphType as ChartType}
        metadata={tab.metadata}
        tabName={tab.name}
      />
    );
  }
  if (tab.type === 'csvtable') {
    return <CsvWidgetExportButton tabName={tab.name} />;
  }
  return <ExportWidgetButton tab={tab} />;
};

export default TabExportButton;
